var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"spectators-container"},[(!_vm.spectators.length)?_c('li',[_vm._v("No spectators present")]):_vm._l((_vm.spectators),function(user){return _c('li',{key:user.id},[_vm._v(" "+_vm._s(user.username)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }